module.exports = {
    "tumbler": {
        "off": "Откл",
        "on": "Вкл"
    }
};